module.exports = __webpack_public_path__ + "static/img/img_paint.784233c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_paint.png
// module id = wW4C
// module chunks = 19